export {default} from './SuccessfulTip';
